import React, { useState } from 'react';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { useAccount } from 'frontastic';
import Button from 'components/commercetools-ui/atoms/button';
import { useParams, useRouter } from 'next/navigation';
import Spinner from '../spinner';

const menuLinks = [
  {
    title: 'Projects',
    link: 'project-builder',
  },
  {
    title: 'My account',
    link: 'my-account',
  },
];

const Dropdown = ({ isMobile = false }) => {
  const { account, logout } = useAccount();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { locale } = useParams();
  const router = useRouter();

  const username = account?.firstName ?? account?.email?.split('@')?.[0] as string;



  //   const handleMouseEnter = () => setIsOpen(true);
  //   const handleMouseLeave = () => setIsOpen(false);

  const menuPosition = isMobile ? 'right-0' : 'left-0';

  console.log(username);

  const logOut = async (e: MouseEvent) => {
    e.preventDefault();
    setLoading(true);
    await logout();
    setLoading(false);
    router.replace('/');
  };

  return loading ? (
    <Spinner />
  ) : (
    <div
      className="relative inline-block"
      //   onMouseEnter={handleMouseEnter}
      //   onMouseLeave={handleMouseLeave}
      onClick={() => setIsOpen(!isOpen)}
    >
      <Button
        variant="ghost"
        size="fit"
        className="search-view-user relative flex items-center text-center text-10"
        role="button"
      >
        <span title={username} className="flex items-center text-10 font-semibold text-[#666] hover:cursor-pointer hover:text-[#333] 2xl:text-14">
          {!isMobile && (
            <span>{username?.length > 8 ? username?.slice(0, 8) + '...' : username}</span>
          )}
          <UserCircleIcon className="w-24 pl-2 text-secondary-black md:w-24 lg:w-16" />
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 18 18"
              fill="none"
              className={`ml-2 w-14 text-secondary-black xl:ml-5 2xl:w-16 ${isOpen ? 'rotate-180' : 'ml-2 xl:ml-5'}`}
            >
              <path
                d="M15.2863 5.85742L9.00056 12.1431L2.71484 5.85742"
                stroke="#090909"
                strokeWidth="1.57143"
                strokeLinecap="square"
              />
            </svg>
          </span>
        </span>
      </Button>

      {isOpen && (
        <div className={`absolute ${menuPosition} mt-9 min-w-[120px] rounded-md !bg-[#fff] text-black shadow-lg`}>
          <ul>
            {menuLinks.map((e: any) => (
              <li
                className="account-dropdown cursor-pointer border-b border-[#EEEEEE] p-9 text-center last:border-none hover:bg-gray-300"
                onClick={() => {
                  if (!account?.firstName && e.title === 'My account') router.push(`/company-registration/`);  
                  else  router.push(`/${locale}/${e.link}`);
                }}
                key={e.title}
              >
                {e.title}
              </li>
            ))}
            <li className="account-dropdown cursor-pointer border-b border-[#EEEEEE] p-9 text-center last:border-none hover:bg-gray-300">
              <button
                type="button"
                onClick={(e: any) => logOut(e)}
                className=" !m-0 !h-full !w-full bg-transparent !p-0  text-black"
              >
                Log out
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
